"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BalanceGroup = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _react = _interopRequireDefault(require("react"));
var _hooks = require("../../../../../hooks");
var _ui = require("../../../../ui");
var _BalanceName = require("../BalanceName");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var StyledPrimaryAmountWithEquivalent = (0, _styledComponents.default)(_ui.PrimaryAmountWithEquivalent)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-top: 10px;\n"])));
var BalanceGroup = function BalanceGroup(_ref) {
  var balanceName = _ref.balanceName;
  var props = (0, _hooks.useWithdrawContext)();
  return /*#__PURE__*/_react.default.createElement(_ui.FormGroup, null, /*#__PURE__*/_react.default.createElement(_ui.Label, null, /*#__PURE__*/_react.default.createElement(_BalanceName.BalanceName, {
    ticker: props.ticker,
    value: balanceName
  })), /*#__PURE__*/_react.default.createElement(StyledPrimaryAmountWithEquivalent, {
    ticker: props.ticker,
    amount: props.balance,
    convertedTicker: props.fiatTicker,
    convertedAmount: props.fiatTickerBalance
  }));
};
exports.BalanceGroup = BalanceGroup;